import { createFileRoute } from '@tanstack/react-router';
import { Projects } from '../../organisms/Projects';

export const Route = createFileRoute('/_authenticated/kb')({
  component: RouteComponent
});

function RouteComponent() {
  return <Projects />;
}
